import { m } from 'framer-motion';

type OpacityWrapperProps = {
  tag?: string,
  duration?: number,
  className?: string,
  children?: React.ReactNode,
  style?: React.CSSProperties,
}

export const OpacityWrapper = ({ tag = 'div', duration = 1, children, className = "", style = {}, ...props }: OpacityWrapperProps) => {
  const CustomMotion = m(tag);

  return (
    <CustomMotion
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1, transition: { duration } }}
      viewport={{ once: true }}
      className={className}
      style={style}
      {...props}
    >
      {children}
    </CustomMotion>
  )
}

interface FlyInTextProps {
  tag?: string,
  y?: string,
  duration?: number,
  className?: string,
  children?: React.ReactNode,
}

export const FlyInText = ({ tag = 'span', y = '20px', duration = 1.5, children = null, className = "", ...props }: FlyInTextProps) => {
  const CustomMotion = m(tag);

  return (
    <CustomMotion
      initial={{ y }}
      whileInView={{ y: 0, transition: { duration } }}
      viewport={{ once: true }}
      className={className}
      {...props}
    >
      {children}
    </CustomMotion>
  )
}

export default null;
